export default __webpack_public_path__ + "static/media/radhika.d524c43f.jpg";